import { render, staticRenderFns } from "./ActionButtonGroup.vue?vue&type=template&id=b84d5d96&scoped=true"
import script from "./ActionButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ActionButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtonGroup.vue?vue&type=style&index=0&id=b84d5d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d5d96",
  null
  
)

export default component.exports